import React from "react";
import { CheckCircle2 } from "lucide-react";

const BookingSuccess = ({ booking, t, lang, onReset }) => (
  <div data-testid="booking-success" className="bg-white border border-[#EAE6DF] p-10 sm:p-14 text-center">
    <CheckCircle2 className="w-14 h-14 text-[#2E4F4F] mx-auto mb-6" strokeWidth={1.2} />
    <h3 className="font-serif text-3xl sm:text-4xl text-[#1A1F24] mb-4">{t.booking.successTitle}</h3>
    <p className="text-[#4A5568] max-w-md mx-auto mb-2">{t.booking.successMsg}</p>
    <p className="text-xs text-[#4A5568] mb-8">
      {lang === "es" ? "Referencia" : "Reference"}:{" "}
      <span className="font-mono text-[#1A1F24]">{booking.id.slice(0, 8).toUpperCase()}</span>
    </p>
    <button
      data-testid="new-booking-btn"
      onClick={onReset}
      className="text-xs uppercase tracking-[0.25em] border border-[#1A1F24] px-6 py-3 hover:bg-[#1A1F24] hover:text-white transition-colors"
    >
      {lang === "es" ? "Nueva reserva" : "New booking"}
    </button>
  </div>
);

export default BookingSuccess;
